<modal
  [condition]="
    currentTime <= sessionTimer.shownWithSecondsRemaining && currentTime !== 0
  "
  [config]="{
    header: {
      title: sessionTimer.title,
      showClose: false
    },
    type: 'popup'
  }"
>
  <ng-container body>
    <p>
      {{ sessionTimer.beforeTimerText }}

      <span class="t-bold">{{ timeDisplay }}</span>

      {{ sessionTimer.afterTimerText }}
    </p>
  </ng-container>

  <ng-container footer>
    <div class="u-flex u-justifyBetween u-maxX">
      <zip-button
        [config]="{
          level: 'medium',
          content: 'Logout'
        }"
        (zipButtonClicked)="endSession()"
      >
      </zip-button>

      <zip-button
        [config]="{
          level: 'high',
          content: 'Extend Session'
        }"
        (zipButtonClicked)="extendSession()"
      >
      </zip-button>
    </div>
  </ng-container>
</modal>
